(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './supabase-kt-supabase-kt.js', './supabase-kt-auth-kt.js', './ktor-ktor-serialization-kotlinx.js', './ktor-ktor-client-core.js', './ktor-ktor-http.js', './kotlinx-coroutines-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./supabase-kt-supabase-kt.js'), require('./supabase-kt-auth-kt.js'), require('./ktor-ktor-serialization-kotlinx.js'), require('./ktor-ktor-client-core.js'), require('./ktor-ktor-http.js'), require('./kotlinx-coroutines-core.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-realtime-kt'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'supabase-kt-realtime-kt'.");
    }
    if (typeof globalThis['supabase-kt-supabase-kt'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-realtime-kt'. Its dependency 'supabase-kt-supabase-kt' was not found. Please, check whether 'supabase-kt-supabase-kt' is loaded prior to 'supabase-kt-realtime-kt'.");
    }
    if (typeof globalThis['supabase-kt-auth-kt'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-realtime-kt'. Its dependency 'supabase-kt-auth-kt' was not found. Please, check whether 'supabase-kt-auth-kt' is loaded prior to 'supabase-kt-realtime-kt'.");
    }
    if (typeof globalThis['ktor-ktor-serialization-kotlinx'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-realtime-kt'. Its dependency 'ktor-ktor-serialization-kotlinx' was not found. Please, check whether 'ktor-ktor-serialization-kotlinx' is loaded prior to 'supabase-kt-realtime-kt'.");
    }
    if (typeof globalThis['ktor-ktor-client-core'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-realtime-kt'. Its dependency 'ktor-ktor-client-core' was not found. Please, check whether 'ktor-ktor-client-core' is loaded prior to 'supabase-kt-realtime-kt'.");
    }
    if (typeof globalThis['ktor-ktor-http'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-realtime-kt'. Its dependency 'ktor-ktor-http' was not found. Please, check whether 'ktor-ktor-http' is loaded prior to 'supabase-kt-realtime-kt'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-realtime-kt'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'supabase-kt-realtime-kt'.");
    }
    globalThis['supabase-kt-realtime-kt'] = factory(typeof globalThis['supabase-kt-realtime-kt'] === 'undefined' ? {} : globalThis['supabase-kt-realtime-kt'], globalThis['kotlin-kotlin-stdlib'], globalThis['supabase-kt-supabase-kt'], globalThis['supabase-kt-auth-kt'], globalThis['ktor-ktor-serialization-kotlinx'], globalThis['ktor-ktor-client-core'], globalThis['ktor-ktor-http'], globalThis['kotlinx-coroutines-core']);
  }
}(function (_, kotlin_kotlin, kotlin_io_github_jan_tennert_supabase_supabase_kt, kotlin_io_github_jan_tennert_supabase_auth_kt, kotlin_io_ktor_ktor_serialization_kotlinx, kotlin_io_ktor_ktor_client_core, kotlin_io_ktor_ktor_http, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var protoOf = kotlin_kotlin.$_$.eh;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var SupabaseClient = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.y;
  var isInterface = kotlin_kotlin.$_$.rg;
  var resolveAccessToken = kotlin_io_github_jan_tennert_supabase_auth_kt.$_$.f;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.gd;
  var initMetadataForLambda = kotlin_kotlin.$_$.hg;
  var VOID = kotlin_kotlin.$_$.d;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var get_supabaseJson = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.a1;
  var KotlinxWebsocketSerializationConverter = kotlin_io_ktor_ktor_serialization_kotlinx.$_$.a;
  var Plugin_getInstance = kotlin_io_ktor_ktor_client_core.$_$.b;
  var MainConfig = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.q;
  var Companion_getInstance = kotlin_kotlin.$_$.d3;
  var DurationUnit_SECONDS_getInstance = kotlin_kotlin.$_$.t3;
  var toDuration = kotlin_kotlin.$_$.tm;
  var toString = kotlin_kotlin.$_$.hh;
  var Duration__toString_impl_8d916b = kotlin_kotlin.$_$.o;
  var toString_0 = kotlin_kotlin.$_$.hp;
  var hashCode = kotlin_kotlin.$_$.bg;
  var getBooleanHashCode = kotlin_kotlin.$_$.vf;
  var Duration__hashCode_impl_u4exz6 = kotlin_kotlin.$_$.g;
  var equals = kotlin_kotlin.$_$.sf;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var Companion_getInstance_0 = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.c;
  var SupabasePluginProvider = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.v;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var Enum = kotlin_kotlin.$_$.en;
  var MainPlugin = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.s;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var getKClass = kotlin_kotlin.$_$.si;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var SessionStatus = kotlin_io_github_jan_tennert_supabase_auth_kt.$_$.j;
  var LogLevel_WARNING_getInstance = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.g;
  var NotAuthenticated = kotlin_io_github_jan_tennert_supabase_auth_kt.$_$.i;
  var Authenticated = kotlin_io_github_jan_tennert_supabase_auth_kt.$_$.h;
  var URLBuilder = kotlin_io_ktor_ktor_http.$_$.a1;
  var path = kotlin_io_ktor_ktor_http.$_$.z1;
  var listOf = kotlin_kotlin.$_$.sa;
  var plus = kotlin_kotlin.$_$.ib;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var FlowCollector = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p1;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y2;
  var Companion_getInstance_1 = kotlin_io_github_jan_tennert_supabase_auth_kt.$_$.e;
  var Auth = kotlin_io_github_jan_tennert_supabase_auth_kt.$_$.l;
  var throwKotlinNothingValueException = kotlin_kotlin.$_$.bp;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var JWTUtils_getInstance = kotlin_io_github_jan_tennert_supabase_auth_kt.$_$.a;
  var System_instance = kotlin_kotlin.$_$.c3;
  var Duration__isNegative_impl_pbysfa = kotlin_kotlin.$_$.j;
  var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q3;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.eg;
  var MutableStateFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.s1;
  var asStateFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.v1;
  var AtomicMutableMap = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.h;
  var SupervisorJob = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.g3;
  var CoroutineScope_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.x2;
  var Mutex = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.o2;
  var AtomicReference = kotlin_kotlin.$_$.ed;
  var AtomicInt = kotlin_kotlin.$_$.dd;
  var LogLevel_DEBUG_getInstance = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.d;
  var UnknownRestException = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.n;
  var resolveUrl = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.r;
  //endregion
  //region block: pre-declaration
  initMetadataForLambda(Realtime$Config$accessToken$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(Config, 'Config', Config, MainConfig);
  initMetadataForCompanion(Companion, VOID, [SupabasePluginProvider]);
  initMetadataForClass(Status, 'Status', VOID, Enum);
  initMetadataForInterface(Realtime, 'Realtime', VOID, VOID, [MainPlugin], [0, 1]);
  initMetadataForClass(Status_0, 'Status', VOID, Enum);
  initMetadataForLambda(RealtimeImpl$init$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(RealtimeImpl$init$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(RealtimeImpl$setAuth$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($setAuthCOROUTINE$, CoroutineImpl);
  initMetadataForClass(RealtimeImpl, 'RealtimeImpl', VOID, VOID, [Realtime], [0, 1]);
  initMetadataForClass(KtorRealtimeWebsocketFactory, 'KtorRealtimeWebsocketFactory', VOID, VOID, VOID, [1]);
  //endregion
  function Realtime$Config$_init_$lambda_1nryeo(_this__u8e3s4) {
    return Unit_instance;
  }
  function Realtime$Config$accessToken$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Realtime$Config$accessToken$slambda).hx1 = function (_this__u8e3s4, $completion) {
    var tmp = this.ix1(_this__u8e3s4, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(Realtime$Config$accessToken$slambda).ja = function (p1, $completion) {
    return this.hx1((!(p1 == null) ? isInterface(p1, SupabaseClient) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(Realtime$Config$accessToken$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = resolveAccessToken(this.gx1_1, get_realtime(this.gx1_1), false, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(Realtime$Config$accessToken$slambda).ix1 = function (_this__u8e3s4, completion) {
    var i = new Realtime$Config$accessToken$slambda(completion);
    i.gx1_1 = _this__u8e3s4;
    return i;
  };
  function Realtime$Config$accessToken$slambda_0(resultContinuation) {
    var i = new Realtime$Config$accessToken$slambda(resultContinuation);
    return constructCallableReference(function (_this__u8e3s4, $completion) {
      return i.hx1(_this__u8e3s4, $completion);
    }, 1);
  }
  function Realtime$Companion$setup$lambda$lambda($config) {
    return function ($this$install) {
      $this$install.fux_1 = new KotlinxWebsocketSerializationConverter(get_supabaseJson());
      $config.lx1_1($this$install);
      return Unit_instance;
    };
  }
  function Realtime$Companion$setup$lambda($config) {
    return function ($this$httpConfig) {
      var tmp = Plugin_getInstance();
      $this$httpConfig.ett(tmp, Realtime$Companion$setup$lambda$lambda($config));
      return Unit_instance;
    };
  }
  var Status_DISCONNECTED_instance;
  var Status_CONNECTING_instance;
  var Status_CONNECTED_instance;
  var Status_entriesInitialized;
  function Status_initEntries() {
    if (Status_entriesInitialized)
      return Unit_instance;
    Status_entriesInitialized = true;
    Status_DISCONNECTED_instance = new Status('DISCONNECTED', 0);
    Status_CONNECTING_instance = new Status('CONNECTING', 1);
    Status_CONNECTED_instance = new Status('CONNECTED', 2);
  }
  function Config(websocketConfig, secure, heartbeatInterval, reconnectDelay, rejoinDelay, maxAttempts, disconnectOnSessionLoss, connectOnSubscribe, websocketFactory, disconnectOnNoSubscriptions, requireValidSession) {
    var tmp;
    if (websocketConfig === VOID) {
      tmp = Realtime$Config$_init_$lambda_1nryeo;
    } else {
      tmp = websocketConfig;
    }
    websocketConfig = tmp;
    secure = secure === VOID ? null : secure;
    var tmp_0;
    if (heartbeatInterval === VOID) {
      // Inline function 'kotlin.time.Companion.seconds' call
      Companion_getInstance();
      tmp_0 = toDuration(15, DurationUnit_SECONDS_getInstance());
    } else {
      tmp_0 = heartbeatInterval;
    }
    heartbeatInterval = tmp_0;
    var tmp_1;
    if (reconnectDelay === VOID) {
      // Inline function 'kotlin.time.Companion.seconds' call
      Companion_getInstance();
      tmp_1 = toDuration(7, DurationUnit_SECONDS_getInstance());
    } else {
      tmp_1 = reconnectDelay;
    }
    reconnectDelay = tmp_1;
    var tmp_2;
    if (rejoinDelay === VOID) {
      // Inline function 'kotlin.time.Companion.seconds' call
      Companion_getInstance();
      tmp_2 = toDuration(2, DurationUnit_SECONDS_getInstance());
    } else {
      tmp_2 = rejoinDelay;
    }
    rejoinDelay = tmp_2;
    maxAttempts = maxAttempts === VOID ? 5 : maxAttempts;
    disconnectOnSessionLoss = disconnectOnSessionLoss === VOID ? true : disconnectOnSessionLoss;
    connectOnSubscribe = connectOnSubscribe === VOID ? true : connectOnSubscribe;
    websocketFactory = websocketFactory === VOID ? null : websocketFactory;
    disconnectOnNoSubscriptions = disconnectOnNoSubscriptions === VOID ? true : disconnectOnNoSubscriptions;
    requireValidSession = requireValidSession === VOID ? false : requireValidSession;
    MainConfig.call(this);
    this.lx1_1 = websocketConfig;
    this.mx1_1 = secure;
    this.nx1_1 = heartbeatInterval;
    this.ox1_1 = reconnectDelay;
    this.px1_1 = rejoinDelay;
    this.qx1_1 = maxAttempts;
    this.rx1_1 = disconnectOnSessionLoss;
    this.sx1_1 = connectOnSubscribe;
    this.tx1_1 = websocketFactory;
    this.ux1_1 = disconnectOnNoSubscriptions;
    this.vx1_1 = requireValidSession;
    var tmp_3 = this;
    tmp_3.wx1_1 = Realtime$Config$accessToken$slambda_0(null);
    this.xx1_1 = null;
  }
  protoOf(Config).tvz = function () {
    return this.vx1_1;
  };
  protoOf(Config).toString = function () {
    return 'Config(websocketConfig=' + toString(this.lx1_1) + ', secure=' + this.mx1_1 + ', heartbeatInterval=' + Duration__toString_impl_8d916b(this.nx1_1) + ', reconnectDelay=' + Duration__toString_impl_8d916b(this.ox1_1) + ', rejoinDelay=' + Duration__toString_impl_8d916b(this.px1_1) + ', maxAttempts=' + this.qx1_1 + ', disconnectOnSessionLoss=' + this.rx1_1 + ', connectOnSubscribe=' + this.sx1_1 + ', websocketFactory=' + toString_0(this.tx1_1) + ', disconnectOnNoSubscriptions=' + this.ux1_1 + ', requireValidSession=' + this.vx1_1 + ')';
  };
  protoOf(Config).hashCode = function () {
    var result = hashCode(this.lx1_1);
    result = imul(result, 31) + (this.mx1_1 == null ? 0 : getBooleanHashCode(this.mx1_1)) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.nx1_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.ox1_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.px1_1) | 0;
    result = imul(result, 31) + this.qx1_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.rx1_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.sx1_1) | 0;
    result = imul(result, 31) + (this.tx1_1 == null ? 0 : hashCode(this.tx1_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ux1_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.vx1_1) | 0;
    return result;
  };
  protoOf(Config).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Config))
      return false;
    if (!equals(this.lx1_1, other.lx1_1))
      return false;
    if (!(this.mx1_1 == other.mx1_1))
      return false;
    if (!equals(this.nx1_1, other.nx1_1))
      return false;
    if (!equals(this.ox1_1, other.ox1_1))
      return false;
    if (!equals(this.px1_1, other.px1_1))
      return false;
    if (!(this.qx1_1 === other.qx1_1))
      return false;
    if (!(this.rx1_1 === other.rx1_1))
      return false;
    if (!(this.sx1_1 === other.sx1_1))
      return false;
    if (!equals(this.tx1_1, other.tx1_1))
      return false;
    if (!(this.ux1_1 === other.ux1_1))
      return false;
    if (!(this.vx1_1 === other.vx1_1))
      return false;
    return true;
  };
  function Companion() {
    Companion_instance = this;
    this.yx1_1 = 'realtime';
    this.zx1_1 = Companion_getInstance_0().ovj('Supabase-Realtime');
    this.ax2_1 = 1;
  }
  protoOf(Companion).t1 = function () {
    return this.yx1_1;
  };
  protoOf(Companion).bx2 = function (init) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config();
    init(this_0);
    return this_0;
  };
  protoOf(Companion).ovl = function (init) {
    return this.bx2(init);
  };
  protoOf(Companion).cx2 = function (builder, config) {
    if (config.tx1_1 == null) {
      builder.mvl(Realtime$Companion$setup$lambda(config));
    }
  };
  protoOf(Companion).pvl = function (builder, config) {
    return this.cx2(builder, config instanceof Config ? config : THROW_CCE());
  };
  protoOf(Companion).dx2 = function (supabaseClient, config) {
    return new RealtimeImpl(supabaseClient, config);
  };
  protoOf(Companion).xvk = function (supabaseClient, config) {
    return this.dx2(supabaseClient, config instanceof Config ? config : THROW_CCE());
  };
  var Companion_instance;
  function Companion_getInstance_2() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function Status(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Status_DISCONNECTED_getInstance() {
    Status_initEntries();
    return Status_DISCONNECTED_instance;
  }
  function Status_CONNECTED_getInstance() {
    Status_initEntries();
    return Status_CONNECTED_instance;
  }
  function Realtime() {
  }
  function get_realtime(_this__u8e3s4) {
    var tmp0 = _this__u8e3s4.tvj();
    // Inline function 'io.github.jan.supabase.plugins.PluginManager.getPlugin' call
    var provider = Companion_getInstance_2();
    // Inline function 'io.github.jan.supabase.plugins.PluginManager.getPluginOrNull' call
    var tmp = tmp0.wvk_1.w2(provider.t1());
    var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, Realtime) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'Plugin ' + provider.t1() + ' not installed or not of type ' + getKClass(Realtime).o() + '. Consider installing ' + getKClass(Realtime).o() + ' within your SupabaseClientBuilder';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  }
  var Status_UNSUBSCRIBED_instance;
  var Status_SUBSCRIBING_instance;
  var Status_SUBSCRIBED_instance;
  var Status_UNSUBSCRIBING_instance;
  var Status_entriesInitialized_0;
  function Status_initEntries_0() {
    if (Status_entriesInitialized_0)
      return Unit_instance;
    Status_entriesInitialized_0 = true;
    Status_UNSUBSCRIBED_instance = new Status_0('UNSUBSCRIBED', 0);
    Status_SUBSCRIBING_instance = new Status_0('SUBSCRIBING', 1);
    Status_SUBSCRIBED_instance = new Status_0('SUBSCRIBED', 2);
    Status_UNSUBSCRIBING_instance = new Status_0('UNSUBSCRIBING', 3);
  }
  function Status_0(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Status_SUBSCRIBED_getInstance() {
    Status_initEntries_0();
    return Status_SUBSCRIBED_instance;
  }
  function RealtimeImpl$init$slambda$slambda(this$0, resultContinuation) {
    this.mx2_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RealtimeImpl$init$slambda$slambda).ox2 = function (it, $completion) {
    var tmp = this.px2(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(RealtimeImpl$init$slambda$slambda).ja = function (p1, $completion) {
    return this.ox2((!(p1 == null) ? isInterface(p1, SessionStatus) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RealtimeImpl$init$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            if (this.mx2_1.vx2_1.u1().equals(Status_CONNECTED_getInstance())) {
              var tmp0_subject = this.nx2_1;
              if (tmp0_subject instanceof Authenticated) {
                this.n9_1 = 1;
                suspendResult = this.mx2_1.jx3(this.nx2_1.nvz_1.pvw_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (tmp0_subject instanceof NotAuthenticated) {
                  if (this.mx2_1.rx2_1.rx1_1) {
                    var tmp0 = Companion_getInstance_2().zx1_1;
                    var level = LogLevel_WARNING_getInstance();
                    var tmp0_elvis_lhs = tmp0.fsu();
                    if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
                      tmp0.fvj(level, null, 'No auth session found, disconnecting from realtime websocket');
                    }
                    this.mx2_1.ix3();
                  }
                  this.n9_1 = 2;
                  continue $sm;
                } else {
                  this.n9_1 = 2;
                  continue $sm;
                }
              }
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(RealtimeImpl$init$slambda$slambda).px2 = function (it, completion) {
    var i = new RealtimeImpl$init$slambda$slambda(this.mx2_1, completion);
    i.nx2_1 = it;
    return i;
  };
  function RealtimeImpl$init$slambda$slambda_0(this$0, resultContinuation) {
    var i = new RealtimeImpl$init$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.ox2(it, $completion);
    }, 1);
  }
  function realtimeBaseUrl($this) {
    var tmp0_elvis_lhs = $this.rx2_1.mx1_1;
    var secure = tmp0_elvis_lhs == null ? $this.qx2_1.vvj() : tmp0_elvis_lhs;
    var prefix = secure ? 'wss://' : 'ws://';
    var tmp1_elvis_lhs = $this.rx2_1.wvn_1;
    var baseUrl = tmp1_elvis_lhs == null ? prefix + $this.qx2_1.rvj() : tmp1_elvis_lhs;
    // Inline function 'io.github.jan.supabase.buildUrl' call
    var builder = URLBuilder(baseUrl);
    path(builder, ['/realtime/v1']);
    return builder.ft7();
  }
  function realtimeWebsocketUrl($this) {
    // Inline function 'io.github.jan.supabase.buildUrl' call
    var baseUrl = realtimeBaseUrl($this);
    var builder = URLBuilder(baseUrl);
    builder.qt5_1.dsq('apikey', $this.qx2_1.svj());
    builder.qt5_1.dsq('vsn', '1.0.0');
    builder.ct7(plus(builder.dt7(), listOf('websocket')));
    return builder.ft7();
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
    this.kx3_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).a1v = function (value, $completion) {
    return this.kx3_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).q3 = function () {
    return this.kx3_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function RealtimeImpl$init$slambda(this$0, resultContinuation) {
    this.tx3_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RealtimeImpl$init$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(RealtimeImpl$init$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RealtimeImpl$init$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0 = this.tx3_1.qx2_1.tvj();
            var provider = Companion_getInstance_1();
            var tmp_0 = tmp0.wvk_1.w2(provider.t1());
            var tmp0_safe_receiver = (!(tmp_0 == null) ? isInterface(tmp_0, Auth) : false) ? tmp_0 : null;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.svy();
            if (tmp1_safe_receiver == null) {
              this.vx3_1 = null;
              this.n9_1 = 2;
              continue $sm;
            } else {
              this.n9_1 = 1;
              var tmp_1 = RealtimeImpl$init$slambda$slambda_0(this.tx3_1, null);
              suspendResult = tmp1_safe_receiver.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.vx3_1 = throwKotlinNothingValueException();
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(RealtimeImpl$init$slambda).q24 = function ($this$launch, completion) {
    var i = new RealtimeImpl$init$slambda(this.tx3_1, completion);
    i.ux3_1 = $this$launch;
    return i;
  };
  function RealtimeImpl$init$slambda_0(this$0, resultContinuation) {
    var i = new RealtimeImpl$init$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function RealtimeImpl$setAuth$slambda(this$0, resultContinuation) {
    this.ex4_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RealtimeImpl$setAuth$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(RealtimeImpl$setAuth$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RealtimeImpl$setAuth$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            var tmp0 = this.ex4_1.xx2_1.y2();
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0.t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              if (element.zbq().u1().equals(Status_SUBSCRIBED_getInstance())) {
                destination.j1(element);
              }
            }

            this.gx4_1 = destination.t();
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!this.gx4_1.u()) {
              this.n9_1 = 3;
              continue $sm;
            }

            var element_0 = this.gx4_1.v();
            this.n9_1 = 2;
            suspendResult = element_0.hx4(this.ex4_1.xvj(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(RealtimeImpl$setAuth$slambda).q24 = function ($this$launch, completion) {
    var i = new RealtimeImpl$setAuth$slambda(this.ex4_1, completion);
    i.fx4_1 = $this$launch;
    return i;
  };
  function RealtimeImpl$setAuth$slambda_0(this$0, resultContinuation) {
    var i = new RealtimeImpl$setAuth$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function $setAuthCOROUTINE$(_this__u8e3s4, token, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qx4_1 = _this__u8e3s4;
    this.rx4_1 = token;
  }
  protoOf($setAuthCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0_elvis_lhs = this.rx4_1;
            if (tmp0_elvis_lhs == null) {
              this.n9_1 = 1;
              suspendResult = this.qx4_1.rx2_1.wx1_1(this.qx4_1.qx2_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.sx4_1 = tmp0_elvis_lhs;
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.sx4_1 = suspendResult;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            var newToken = this.sx4_1;
            if (!(newToken == null)) {
              var tmp1_elvis_lhs = JWTUtils_getInstance().twi(newToken).owi_1.kwh_1.fwi();
              var tmp_0;
              if (tmp1_elvis_lhs == null) {
                var message = 'exp claim missing';
                throw IllegalStateException_init_$Create$(toString(message));
              } else {
                tmp_0 = tmp1_elvis_lhs;
              }
              var exp = tmp_0;
              var now = System_instance.fp();
              var diff = exp.zp(now);
              if (Duration__isNegative_impl_pbysfa(diff)) {
                var tmp0 = Companion_getInstance_2().zx1_1;
                var level = LogLevel_WARNING_getInstance();
                var tmp0_elvis_lhs_0 = tmp0.fsu();
                if (level.i3(tmp0_elvis_lhs_0 == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs_0) >= 0) {
                  tmp0.fvj(level, null, 'Token is expired. Not sending it to realtime.');
                }
                return Unit_instance;
              }
            }

            this.qx4_1.ax3_1.b9(newToken);
            launch(this.qx4_1.yx2_1, VOID, VOID, RealtimeImpl$setAuth$slambda_0(this.qx4_1, null));
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function RealtimeImpl(supabaseClient, config) {
    this.qx2_1 = supabaseClient;
    this.rx2_1 = config;
    var tmp = this;
    var tmp0_elvis_lhs = this.rx2_1.tx1_1;
    tmp.sx2_1 = tmp0_elvis_lhs == null ? new KtorRealtimeWebsocketFactory(this.qx2_1.uvj().fvm_1) : tmp0_elvis_lhs;
    this.tx2_1 = null;
    this.ux2_1 = MutableStateFlow(Status_DISCONNECTED_getInstance());
    this.vx2_1 = asStateFlow(this.ux2_1);
    this.wx2_1 = new AtomicMutableMap([]);
    this.xx2_1 = this.wx2_1;
    this.yx2_1 = CoroutineScope_0(this.qx2_1.yvj().xj(SupervisorJob()));
    this.zx2_1 = Mutex();
    this.ax3_1 = new AtomicReference(null);
    this.bx3_1 = null;
    this.cx3_1 = null;
    this.dx3_1 = new AtomicInt(0);
    this.ex3_1 = new AtomicInt(0);
    var tmp_0 = this;
    var tmp0_elvis_lhs_0 = this.rx2_1.xx1_1;
    tmp_0.fx3_1 = tmp0_elvis_lhs_0 == null ? this.qx2_1.wvj() : tmp0_elvis_lhs_0;
    this.gx3_1 = realtimeWebsocketUrl(this);
    this.hx3_1 = new AtomicInt(0);
  }
  protoOf(RealtimeImpl).yvn = function () {
    return this.qx2_1;
  };
  protoOf(RealtimeImpl).ebw = function () {
    return this.rx2_1;
  };
  protoOf(RealtimeImpl).xvj = function () {
    return this.ax3_1.a9();
  };
  protoOf(RealtimeImpl).tvn = function () {
    return 1;
  };
  protoOf(RealtimeImpl).uvn = function () {
    return Companion_getInstance_2().yx1_1;
  };
  protoOf(RealtimeImpl).rvz = function () {
    return this.fx3_1;
  };
  protoOf(RealtimeImpl).odl = function () {
    launch(this.yx2_1, VOID, VOID, RealtimeImpl$init$slambda_0(this, null));
  };
  protoOf(RealtimeImpl).ix3 = function () {
    // Inline function 'io.github.jan.supabase.logging.d' call
    var tmp0 = Companion_getInstance_2().zx1_1;
    // Inline function 'io.github.jan.supabase.logging.SupabaseLogger.log' call
    var level = LogLevel_DEBUG_getInstance();
    var tmp0_elvis_lhs = tmp0.fsu();
    if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
      var tmp$ret$2 = 'Closing websocket connection';
      tmp0.fvj(level, null, tmp$ret$2);
    }
    var tmp0_safe_receiver = this.cx3_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.b1b();
    }
    var tmp1_safe_receiver = this.tx2_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.ix3();
    }
    this.tx2_1 = null;
    var tmp2_safe_receiver = this.bx3_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.b1b();
    }
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this.xx2_1.s1().t();
    while (_iterator__ex2g4s.u()) {
      // Inline function 'kotlin.collections.component2' call
      var channel = _iterator__ex2g4s.v().u1();
      channel.tx4();
    }
    this.ux2_1.s21(Status_DISCONNECTED_getInstance());
  };
  protoOf(RealtimeImpl).jx3 = function (token, $completion) {
    var tmp = new $setAuthCOROUTINE$(this, token, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(RealtimeImpl).svn = function (response, $completion) {
    return new UnknownRestException('Unknown error in realtime plugin', response);
  };
  function KtorRealtimeWebsocketFactory(httpClient) {
    this.ux4_1 = httpClient;
  }
  //region block: post-declaration
  protoOf(RealtimeImpl).vvn = resolveUrl;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Companion_getInstance_2;
  //endregion
  return _;
}));

//# sourceMappingURL=supabase-kt-realtime-kt.js.map
